module.exports = __webpack_public_path__ + "img/水印logo--大图.b6e4c179.png";